import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Input } from '../ui/components';
import { Icon } from '../ui/icons';
import { auth as authApi } from '../lib/api';
import { useT } from '../i18n';
import './LoginPage.css';

export default function ForgotPasswordPage() {
  const t = useT();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) {
      setError(t('Enter your email address.'));
      return;
    }
    setLoading(true);
    try {
      await authApi.forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(err?.message || t('Something went wrong. Please try again.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ps-scope pp-login">
      <aside className="pp-login__brand">
        <div className="pp-login__logo">
          <span className="pp-login__logo-mark">P</span>
          <span>Prostay Procurement</span>
        </div>
        <div className="pp-login__pitch">
          <h1 className="pp-login__headline">{t('Forgot your password?')}</h1>
          <p className="pp-login__sub">{t("It happens. We'll email you a link to choose a new one.")}</p>
        </div>
      </aside>

      <section className="pp-login__panel">
        <div className="pp-login__card">
          {sent ? (
            <>
              <h2 className="pp-login__title">{t('Check your email')}</h2>
              <p className="pp-login__desc">
                {t('If an account exists for {email}, a reset link is on its way. The link expires in 60 minutes.', { email: email.trim() })}
              </p>
              <Button variant="secondary" size="lg" fullWidth onClick={() => setSent(false)}>
                {t('Send again')}
              </Button>
              <p className="pp-login__foot">
                <Link to="/login" className="pp-login__link">{t('Back to sign in')}</Link>
              </p>
            </>
          ) : (
            <>
              <h2 className="pp-login__title">{t('Reset your password')}</h2>
              <p className="pp-login__desc">{t("Enter the email you sign in with and we'll send you a reset link.")}</p>
              <form className="pp-login__form" onSubmit={submit}>
                {error && (
                  <div className="pp-login__error" role="alert">
                    <Icon.CircleAlert size={16} />
                    <span>{error}</span>
                  </div>
                )}
                <Input
                  label={t('Email')}
                  type="email"
                  autoFocus
                  autoComplete="username"
                  placeholder="you@company.com"
                  leadingIcon={<Icon.Mail size={16} />}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Button type="submit" variant="primary" size="lg" fullWidth loading={loading}>
                  {t('Email me a reset link')}
                </Button>
              </form>
              <p className="pp-login__foot">
                <Link to="/login" className="pp-login__link">{t('Back to sign in')}</Link>
              </p>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
